import { useState, useRef, useEffect } from "react";
import ICON_CLOSE_X_2 from "../../../Assets/jsx/ICON_CLOSE_X_2";

const Draggable = (props) => {
  const {
    children,
    style,
    initialPosition = { x: 0, y: 0 },
    title,
    toggle_close,
  } = props;
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({
    x: initialPosition.x,
    y: initialPosition.y,
  });
  const dragRef = useRef(null);

  const handleMouseDown = (e) => {
    if (e.target.closest(".no-drag")) return;

    setIsDragging(true);
    const initialX = e.clientX - dragRef.current.getBoundingClientRect().left;
    const initialY = e.clientY - dragRef.current.getBoundingClientRect().top;

    const handleMouseMove = (e) => {
      const newX = e.clientX - initialX;
      const newY = e.clientY - initialY;
      setPosition({ x: newX, y: newY });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const handleTouchStart = (e) => {
    // Prevent dragging if touching inside a .no-drag container
    if (e.target.closest(".no-drag")) return;

    setIsDragging(true);
    const initialX =
      e.touches[0].clientX - dragRef.current.getBoundingClientRect().left;
    const initialY =
      e.touches[0].clientY - dragRef.current.getBoundingClientRect().top;

    const handleTouchMove = (e) => {
      const newX = e.touches[0].clientX - initialX;
      const newY = e.touches[0].clientY - initialY;
      setPosition({ x: newX, y: newY });
    };

    const handleTouchEnd = () => {
      setIsDragging(false);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };

    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);
  };

  // Prevent wheel events inside .no-drag from bubbling out of the Draggable.
  // Must use a native listener with { passive: false } so stopPropagation works
  // for trackpad tilt (horizontal scroll) which browsers fire as passive by default.
  useEffect(() => {
    const el = dragRef.current;
    if (!el) return;

    const handleWheel = (e) => {
      if (e.target.closest(".no-drag")) {
        e.stopPropagation();
      }
    };

    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, []);

  return (
    <div
      className="draggable-panel flex flex_col background_white"
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      ref={dragRef}
      style={{
        cursor:
          toggle_close || title ? "default" : isDragging ? "grabbing" : "grab",
        zIndex: "2",
        position: "fixed",
        left: position.x,
        top: position.y,
        userSelect: "none",
        ...style,
        borderRadius: "15px",
      }}
    >
      {(toggle_close || title) && (
        <div
          style={{
            cursor: isDragging ? "grabbing" : "grab",
            borderRadius: "15px",
          }}
          className="draggable-panel flex justify_between background_white"
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
        >
          {title && title}
          {toggle_close && (
            <button
              onClick={toggle_close}
              className="close_button background_black"
              data-mapid="closeEdit"
            >
              <ICON_CLOSE_X_2
                color="#fff"
                style={{
                  width: "15px",
                }}
              />
            </button>
          )}
        </div>
      )}

      <div>{children}</div>
    </div>
  );
};

export default Draggable;
